import { APIResponse } from '@hedgit/lib/types/api'
import { ThunkAction } from '@hedgit/lib/types/redux-thunk'

import { get } from '@hedgit/lib/utils/axios'

import { BrokerWithSubscriptionPlan } from '@hedgit/lib/interfaces/broker'

import { getBrokersPending, getBrokersFulfilled, getBrokersFailed } from './actions'
import { BrokersActionTypes } from './types'

interface Response {
  brokers: BrokerWithSubscriptionPlan[];
}

export const getBrokers = (): ThunkAction<void, unknown, unknown, BrokersActionTypes> => {
  return async (dispatch) => {
    dispatch(getBrokersPending())
    try {
      const response = await get<APIResponse<Response>>('/brokers')
      dispatch(getBrokersFulfilled(response.data.brokers))
    } catch (error) {
      dispatch(getBrokersFailed(error))
    }
  }
}
